import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';
import { NzSwitchModule } from 'ng-zorro-antd/switch';
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';

import { ToastModule } from '@libs/src/toast/toast.module';
import { ZendeskLinkModule } from '@libs/src/zendesk-link/zendesk-link.module';

import { SettingsScreenRecordingComponent } from './settings-screen-recording.component';

@NgModule({
  declarations: [SettingsScreenRecordingComponent],
  exports: [SettingsScreenRecordingComponent],
  imports: [
    CommonModule,
    FlexLayoutModule,
    FormsModule,
    MatIconModule,
    NzSwitchModule,
    NzToolTipModule,
    ToastModule,
    ZendeskLinkModule,
  ],
})
export class SettingsScreenRecordingModule {}
